import React, { FC } from 'react';

import ChooseSubscriptionModal, {
  ReasonType,
} from '~/modules/settings/components/modals/ChooseSubscriptionModal';
import PolyllmRestoreModal from '~/projects/polyllm-chat/components/SubscriptionModal/PolyllmRestoreModal';

export type SubscriptionModalProps = {
  type: ReasonType;
  onClose: () => void;
};

/**
 * PolyLLM-specific implementation of the subscription modal slot
 * injected via `ProjectBehaviorStrategy.SubscriptionModal`.
 *
 * For `NO_ACTIVE_SUBSCRIPTION` we always render the ChatWithAI-styled
 * restore modal: `useHandleSpecialBackendErrors` only opens this slot for
 * restorable plans and short-circuits every other status to the upgrade
 * paywall via `shouldShowUpgradePaywallForInactiveSubscriptionStatus`
 * (JD-2817). Other reasons keep delegating to `ChooseSubscriptionModal`.
 */
const PolyllmSubscriptionModal: FC<SubscriptionModalProps> = ({
  type,
  onClose,
}) => {
  if (type === ReasonType.NO_ACTIVE_SUBSCRIPTION) {
    return <PolyllmRestoreModal onClose={onClose} />;
  }

  return <ChooseSubscriptionModal type={type} onClose={onClose} />;
};

export default PolyllmSubscriptionModal;
